// Deep links into Bootstrap widgets, so a link from another page lands on the right content:
//   /drills#u7           opens the U7 tab (the tab list opts in with data-tabs-hash; each tab
//                        button carries its hash in data-hash). Choosing a tab updates the hash
//                        without adding history entries.
//   /programs#age-u7     opens the modal with that id.
import Modal from 'bootstrap/js/dist/modal';
import Tab from 'bootstrap/js/dist/tab';

export function initDeepLinks(root = document) {
  const list = root.querySelector('[data-tabs-hash]');
  if (list) {
    const triggers = Array.from(list.querySelectorAll('[data-bs-toggle="tab"]'));
    const open = (scroll) => {
      const trigger = triggers.find((t) => t.dataset.hash === location.hash.slice(1));
      if (!trigger) return;
      Tab.getOrCreateInstance(trigger).show();
      if (scroll) list.scrollIntoView({ block: 'start' });
    };
    list.addEventListener('shown.bs.tab', (event) => {
      const hash = event.target.dataset.hash;
      if (!hash) return;
      const url = hash === 'all' ? location.pathname + location.search : `#${hash}`;
      history.replaceState(null, '', url);
    });
    window.addEventListener('hashchange', () => open(true));
    open(true);
  }
  const id = location.hash.slice(1);
  const modal = id ? Array.from(root.querySelectorAll('.modal')).find((m) => m.id === id) : null;
  if (modal) Modal.getOrCreateInstance(modal).show();
}
